import * as React from 'react';
import {useEffect, useContext} from 'react';
import {Like} from '../queries/like';
import {LikeStatusContext} from '../likeStatusContext';
import {LikeCountContext} from '../likeCountContext';

export const useLikeStatus = (type, contentId) => {
  const {state, dispatch} = useContext(LikeStatusContext);
  useEffect(() => {
    console.log(!state);
    state.length === 0 &&
      Like.fetchLikeStatus(type, contentId).then(response =>
        dispatch({type: 'initLike', payload: response}),
      );
  }, []);

  const like = () => {
    dispatch({type: 'clickLike'});
    Like.addLike(type, contentId);
  };

  const dislike = () => {
    dispatch({type: 'clickLike'});
    Like.removeLike(type, contentId);
  };

  return {like, dislike, isLiked: state};
};

export const useLikeCount = (type, contentId) => {
  const {state, dispatch} = useContext(LikeCountContext);
  useEffect(() => {
    console.log(!state);
    state.length === 0 &&
      Like.fetchLikeCount(type, contentId).then(response =>
        dispatch({type: 'initCount', payload: response}),
      );
  }, []);

  const increase = () => {
    dispatch({type: 'addLikeCount'});
  };

  const decrease = () => {
    dispatch({type: 'removeLikeCount'});
  };

  const getLikeCount = () => {
    const likeCount = state;
    if (likeCount <= 999) return likeCount;
    if (likeCount > 999) {
      return `${likeCount / 1000}K`;
    }
  };

  return {increase, decrease, likeCount: getLikeCount()};
};
